import * as React from 'react'
import { clsx } from 'clsx'
import { PlateElement } from 'platejs/react'
import type { PlateElementProps } from 'platejs/react'

import styles from './ParagraphElement.module.css'

const ParagraphElement = React.forwardRef<
  HTMLParagraphElement,
  PlateElementProps
>(({ children, className, ...props }, ref) => (
  <PlateElement
    {...props}
    ref={ref}
    as="p"
    className={clsx(styles.paragraph, className)}
  >
    {children}
  </PlateElement>
))

ParagraphElement.displayName = 'RichTextField.ParagraphElement'

export { ParagraphElement }
